<template>
    <div class="container">
        <div class="row" id="vehicles">
            <div v-for="vehicle in vehicles" :key="vehicle.id" class="car four col-md-3">
                <div class="car-health">
                    <a :href="'/vehicle/' + vehicle.id + '/health'">
                            <i class="fas fa-tools"></i>
                        </a>
                    
                </div>
                <div class="counter-box colored"> 
                    <i class="fas fa-car"></i>
                    <p>
                        <a :href="'/vehicle/' + vehicle.id + '/trip'">
                            {{ vehicle.make }} {{ vehicle.model }}
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { apiClient } from '../helpers/api-client';
const localStorageHelper = require('../helpers/local-storage');

export default {
    name: 'Vehicle',
    setup() {
        return {
            userId: localStorageHelper.getLoggedInUser().userId
        }
    },
    data() {
        return {
            vehicles: []
        }
    },
    created() {
        this.fetchVehicles();
    },
    methods: {
        async fetchVehicles() {
            const result = await apiClient(`users/${this.userId}/ownedVehicles`, 'GET');
            this.vehicles = result.data;
            // for now we will set the first owned vehicle as current vehicle
            localStorageHelper.setCurrentVehicle(result.data[0].id);
        }
    }
}
</script>

<style scoped>
.container {
    margin-top: 20px;
    margin-bottom: 20px;
}
.car {
    position: relative;
}

.counter-box {
    display: block;
    background: #f6f6f6;
    padding: 40px 20px 37px;
    text-align: center;
    border: 1px solid #CCCCCC;
    margin-bottom: 30px;
    -webkit-box-shadow: 0 10px 6px -6px #777;
    -moz-box-shadow: 0 10px 6px -6px #777;
    box-shadow: 0 10px 6px -6px #777;
    border-radius: 5px;
}

.counter-box p {
    margin: 5px 0 0;
    padding: 0;
    color: #909090;
    font-size: 18px;
    font-weight: 500
}

.counter-box i {
    font-size: 60px;
    margin: 0 0 15px;
    color: #d2d2d2
}

.car-health {
  position: absolute;
  right: 0px;
  top: -20px;
  font-size: 40px;
}
</style>